import React from 'react';
import { IconBase, IconBaseProps } from './IconBase';

export const Profile: React.FunctionComponent<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 20 20">
    <path d="M13.7,10.72A6,6,0,1,0,10,12a8,8,0,0,1,8,8h2A10,10,0,0,0,13.7,10.72ZM10,10a4,4,0,1,1,4-4A4,4,0,0,1,10,10Z" />
    <path d="M4,14.66,2.5,13.34A10.15,10.15,0,0,0,0,20H10V18H2.26A8,8,0,0,1,4,14.66Z" />
  </IconBase>
);
